import Plural from 'components/utils/Formatters/Plural'
import config from 'constants/config'
import React from 'react'

interface Props {
  points: number
  abbreviated?: boolean
}

function FormatLoyaltyPoints({ points, abbreviated }: Props) {
  if (abbreviated) {
    return <Plural
      singular={config.loyalty.pointsUnitAbbreviation}
      count={points}
      withCount
    />
  }
  return <Plural
    singular={config.loyalty.pointsUnit}
    count={points}
    withCount
  />
}

export default FormatLoyaltyPoints
